import React from 'react';

/**
 * Gold coin SVG — replaces U+1FA99 🪙, which often fails to render on Windows Chromium
 * (missing glyph in Segoe UI Emoji / system fonts).
 */
export default function CoinIcon({ size = 16, className = '', style = {}, title = 'Coins' }) {
    const a11y = title
        ? { role: 'img', 'aria-label': title }
        : { 'aria-hidden': true };

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width={size}
            height={size}
            className={className}
            style={{
                display: 'inline-block',
                verticalAlign: '-0.125em',
                flexShrink: 0,
                ...style,
            }}
            {...a11y}
        >
            {title ? <title>{title}</title> : null}
            {/* Thickness / bottom edge */}
            <circle cx="12" cy="13" r="10" fill="#92400e" />
            {/* Main coin disc */}
            <circle cx="12" cy="11" r="10" fill="#f59e0b" />
            {/* Outer rim */}
            <circle cx="12" cy="11" r="8.6" fill="#fbbf24" stroke="#b45309" strokeWidth="1.2" />
            {/* Inner raised face */}
            <circle cx="12" cy="11" r="6.2" fill="#fcd34d" />
            {/* Inner ring */}
            <circle cx="12" cy="11" r="5.1" fill="none" stroke="#d97706" strokeWidth="0.85" />
            {/* Highlight */}
            <ellipse cx="8.6" cy="7.8" rx="3.2" ry="1.8" fill="#fefce8" opacity="0.7" />
            {/* Center $ — keeps it readable as a coin at small sizes */}
            <path
                fill="#92400e"
                d="M12.65 7.05v-.75h-1.3v.75c-1.25.18-2 .9-2 1.95 0 1 .65 1.6 2 1.95v2.45c-.65-.14-1.05-.48-1.2-.9l-1.25.38c.28 1 1.08 1.6 2.45 1.82v.8h1.3v-.8c1.3-.18 2.1-.95 2.1-2.1 0-1.1-.7-1.75-2.1-2.1V9.05c.6.14.98.48 1.12.9l1.22-.32c-.22-.95-.98-1.55-2.34-1.78zm-1.3 1.3c-.65.14-.98.42-.98.9s.33.75.98.9V8.35zm1.3 5.3c.7-.14 1.05-.48 1.05-1 0-.52-.35-.85-1.05-1v2z"
            />
        </svg>
    );
}
